<template>
  <div class="rank-area">
    <div class="content">
      <div class="list-con">
        <div class="list" v-for="(item, index) in data" :key="index">
          <div class="rank">{{ index+1 }}</div>
          <div class="name">{{ item.nickName }}</div>
          <div class="sec">{{ item.sec }} 秒</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  name: 'Ranking',
  data() {
    return {
      data: [],
    };
  },
  methods: {
    getData() {
      const vm = this;
      firebase.database().ref('records').once('value').then((snapshot) => {
        const obj = snapshot.val();
        const keys = Object.keys(obj);
        vm.data = keys.map(key => obj[key]);
        vm.data = vm.data.filter(item => item.sec > 0)
          .sort((a, b) => (a.sec > b.sec ? 1 : -1));
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
  $dark-1: #00251A;
  $dark-2: #004D40;
  $dark-3: #2BBD7E;
  $dark-4: #9FFFE0;
  .rank-area{
    background-color: $dark-4;
    display: flex;
    justify-content: center;
    .content{
      width: 1070px;
      background-image: url('../../assets/img/flex-bg-leaderboard-1.jpg');
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center top;
      min-height: 100vh;
      position: relative;
      .list-con{
        // position: absolute;
        width: 100%;
        padding: 5px 169px 50px 140px;
        margin-top: 220px;
        min-height: calc(100vh - 220px);
        background-size: 100% auto;
        background-image: url('../../assets/img/flex-bg-leaderboard-2.jpg');
      }
      .list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: $dark-3;
        margin-bottom: 16px;
        padding: 10px;
        font-size: 24px;
        font-weight: bold;
        transition: all 0.3s ease-in-out;
        &:nth-child(1) {
          background-color: #fff;
          border: 2px solid $dark-1;
          color: $dark-3;
        }
        &:nth-child(2) {
          background-color: $dark-1;
          color: $dark-4;
          border: 2px solid $dark-1;
        }
        &:nth-child(3) {
          background-color: $dark-4;
          color: $dark-1;
          border: 2px solid $dark-1;
        }
        &:hover {
          transform: scale(1.02);
          border-color: #fff;
        }
      }
    }
  }
</style>
